var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.resultData)?_c('div',{staticStyle:{"padding":"2rem"}},_vm._l((this.resultData),function(result,index){return _c('chart',{key:result.id,attrs:{"result":result,"index":index,"options":_vm.options}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }